// extracted by mini-css-extract-plugin
export default {"create-contact-form":"CreateContactsForm_create-contact-form__lwYVf","selected-tags":"CreateContactsForm_selected-tags__4+Wrv"};